import React, { useContext } from 'react';

import { useHistory } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';

import { AppButton } from '@vyce/core/src/components/AppButton';

import { DeviceContext } from '../../../contexts';
import useStyles from '../styles';
import { MAIN_CONTAINER_ID } from '../../../constants';

interface Props {
  open: boolean;
  closeDialog: Function;
  /** The server's 202 message; shown as is */
  message?: string;
  /** Legend has no User Management route to jump to */
  hideUserManagementLink?: boolean;
}

export const SuccessDialog: React.FC<Props> = ({
  open,
  closeDialog,
  message,
  hideUserManagementLink = false,
}) => {
  const { isMobile } = useContext(DeviceContext);
  const history = useHistory();
  const classes = useStyles();

  const handleClose = () => {
    closeDialog();
  };

  const handleClick = () => {
    handleClose();
    history.push('/user-management/company-invites');
  };

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={isMobile}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      {/* The run carries on after the response: some people get invited, some added straight away */}
      <DialogTitle id="responsive-dialog-title">We're on it</DialogTitle>

      <DialogContent>
        {message && (
          <Typography className={classes.dialogText} style={{ marginBottom: 12 }}>
            {message}
          </Typography>
        )}
        <Typography className={classes.dialogText}>
          New users are added with standard permissions. You can customise user permissions and settings in
          the <span className={classes.moduleName}>User Management</span> tab.
        </Typography>
      </DialogContent>

      <DialogActions>
        {!hideUserManagementLink && (
          <AppButton size="large" variant="outlined" onClick={handleClick}>
            Go to User Management
          </AppButton>
        )}

        <AppButton size="large" color="primary" variant="contained" onClick={handleClose}>
          OK
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};
